<script>
import visibilitySingle from './visibility-single'

export default {
  name: 'visibilitySingleList',
  components: {
    visibilitySingle
  },
  computed: {
    visibilityoptionssingle () {
      const state = this.$store.getters['visibilitySingleList/getState']
      return state.visibilityoptionssingle.filter(item => item.type !== 'hide')
      // return state.visibilityoptionssingle
    }
  },
  methods: {
    onClickChild (value) {
      // console.log(value) // someValue
      this.$store.commit('visibilitySingleList/setVisibility', {optionName: value.name, switch: value.visible})
    }
  }
}
</script>

<template>
<div>
  <md-list-item v-for="menuItem in visibilityoptionssingle" :key="menuItem.id">
    <visibilitySingle :option="menuItem" @clicked="onClickChild"/>
  </md-list-item>
</div>
</template>

<style lang="scss" scoped>
</style>
